var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.968 20.2846H1.9518C1.42385 20.2846 1 19.8607 1 19.3328V9.31655C1 8.7886 1.42385 8.36475 1.9518 8.36475H11.968C12.496 8.36475 12.9198 8.7886 12.9198 9.31655V19.3328C12.9198 19.8607 12.496 20.2846 11.968 20.2846Z",
    fill: "#FF8833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74797 5.33135C4.7241 5.35522 4.71387 5.38294 4.71387 5.40879V9.75138H3.22668V5.40879C3.22668 4.52965 3.94627 3.81006 4.82541 3.81006H8.99698C9.87612 3.81006 10.5957 4.52965 10.5957 5.40879V9.66215H9.10852V5.40879C9.10852 5.38294 9.09829 5.35522 9.07442 5.33135C9.05054 5.30747 9.02282 5.29725 8.99698 5.29725H4.82541C4.79956 5.29725 4.77185 5.30747 4.74797 5.33135Z",
    fill: "#FF8833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56973 12.6922C8.56973 11.7999 7.84844 11.0786 6.95613 11.0786C6.06382 11.0786 5.34253 11.7999 5.34253 12.6922C5.34253 13.2945 5.67715 13.8225 6.16792 14.0976L5.34253 17.4884H6.95613H8.56973L7.74434 14.0976C8.23511 13.8225 8.56973 13.2945 8.56973 12.6922Z",
    fill: "#8D33FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9542 16.9376C21.7036 16.2416 20.9362 15.8805 20.2402 16.1311C19.5442 16.3817 19.1831 17.149 19.4337 17.8451C19.6843 18.5411 20.4517 18.9021 21.1477 18.6515C21.8437 18.4009 22.2048 17.6336 21.9542 16.9376ZM19.9014 15.1902C21.1171 14.7525 22.4574 15.3832 22.895 16.5988C23.3327 17.8144 22.7021 19.1547 21.4865 19.5924C20.2708 20.0301 18.9305 19.3994 18.4929 18.1838C18.0552 16.9682 18.6858 15.6279 19.9014 15.1902Z",
    fill: "#8D33FF",
    stroke: "#8D33FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5622 3.71919C15.822 3.62564 16.1084 3.76043 16.202 4.02024L20.3041 15.4136C20.3977 15.6734 20.2629 15.9598 20.0031 16.0534C19.7433 16.1469 19.4568 16.0121 19.3633 15.7523L15.2611 4.359C15.1676 4.09919 15.3023 3.81273 15.5622 3.71919Z",
    fill: "#8D33FF",
    stroke: "#8D33FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 5.05371L17.1279 8.80347L15.2908 9.46493C15.031 9.55847 14.7446 9.42368 14.651 9.16387L13.6397 6.35498C13.5461 6.09517 13.6809 5.80871 13.9407 5.71516L15.7778 5.05371Z",
    fill: "#8D33FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.21b463c26a309e568ac4922c98eae19e.svg";
export { ForwardRef as ReactComponent };